module.exports = __webpack_public_path__ + "static/img/banner5.4908f12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/banner5.jpg
// module id = //8X
// module chunks = 0